import { computed } from 'vue'

export function isKeyOfObject<T extends object>(
	key: string | number | symbol,
	obj: T
): key is keyof T {
	return key in obj
}

export function hasLetters(str: string) {
	const regExp = /[a-zA-Z]/g
	return regExp.test(str.replace(/-/g, ''))
}

type StringArrayMap = Record<string, string[]>

/**
 * Checks if all arrays in the object share at least one common string.
 * @param obj - Object with string array values
 * @returns `false` if no common string exists across all arrays
 */
export function hasAtLeastOneMatchAcrossAll(obj: StringArrayMap): boolean {
	const arrays = Object.values(obj)

	if (arrays.length < 2) return false // Nothing to compare

	const [first, ...rest] = arrays
	if (!first) return true

	return first.some((item) => rest.every((arr) => arr.includes(item)))
}

type OsType = 'ios' | 'android' | 'windows' | 'macos' | 'linux' | 'other'
/**
 * Detects the current operating system based on the browser's user agent string.
 * @returns A computed ref resolving to one of: `'ios' | 'android' | 'windows' | 'macos' | 'linux' | 'other'`
 */
export const checkOsType = computed<OsType>(() => {
	const ua = navigator.userAgent

	if (/iPad|iPhone|iPod/.test(ua)) return 'ios'
	if (/Android/.test(ua)) return 'android'
	if (/Win/.test(ua)) return 'windows'
	if (/Mac/.test(ua)) return 'macos'
	if (/Linux/.test(ua)) return 'linux'

	return 'other'
})
